'use client';

import { MutableRefObject, useCallback, useEffect, useRef, useState } from 'react';

export function useIntersectionObserver(
  ref: MutableRefObject<Node | null>,
  options: IntersectionObserverInit = {}): boolean {
  const {
    threshold = 1,
    root = null,
    rootMargin = '0px',
  } = options;
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  const previousObserver = useRef<IntersectionObserver>(undefined);
  const init = useCallback((node?: Node) => {
    if (previousObserver.current) {
      previousObserver.current.disconnect();
      previousObserver.current = undefined;
    }
    if (isElement(node)) {
      const observer = new IntersectionObserver(([entry]) => {
        setEntry(entry);
      }, { threshold, root, rootMargin });
      observer.observe(node);
      previousObserver.current = observer;
    }
  }, [threshold, root, rootMargin]);
  useEffect(() => {
    if (ref.current) {
      init(ref.current);
    }
  }, [init, ref]);
  // console.log(entry);
  const isIntersecting = entry ? entry.isIntersecting : false;
  return isIntersecting;
}

export function isElement(node?: Node): node is Element {
  return node?.nodeType === Node.ELEMENT_NODE;
}
